(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else{
        root.extant=factory();
    }
})(function () {
    'use strict'
    var STRING  = "string";
    var COMMA   = ",";
    var DOT     = ".";
    var NULL = null;
    var UNDEF;
    var FALSEOK;

    /**
     * Confirm an object path exists
     * @param  {object}     obj       object to test agains
     * @param  {string}     path      Dot delimited path
     * @return {boolean}              True if full path exist
     */
    function checkDeep(obj, paths, depth, end ){
        if(depth === end){
            return notNullOrUndef(obj);
        }
        return obj == null ? false : checkDeep(obj[paths[depth]], paths, depth+1, end);
    }

    /**
     * Confirm a set of properties exist on an object
     * @param  {object}     obj        object to test agains
     * @param  {string}     props      Comma delimited set of properties
     * @return {boolean}               True if all properties exist 
     */
    function checkSet(obj,paths) {
        var i = 0;
        var len = paths.length;
        for(; i < len; i++){
            if(!checkPaths(obj, paths[i])){
                return false;
            }
        }
        return true;
    }

    function checkPaths(obj, path){
        var paths = typeof path === STRING && (path.indexOf(DOT) !== -1 ? path.split(DOT) : [path]);
        return checkDeep(obj, paths, 0, paths.length);
    }

    /**
     * Check if a object is undefined or null
     * @param  {mixed}  thing     Object to test
     * @return {boolean}          True if false or null
     */
    function notNullOrUndef(thing){
        return !(thing === UNDEF  || thing === NULL || (thing === false && !FALSEOK));
    }

    return function(obj, path, falseNotOk) {
        FALSEOK = falseNotOk !==true;
        if(notNullOrUndef(obj)){
            if(path===UNDEF){
                return true;
            }
            path = typeof path === STRING && path.indexOf(COMMA) !== -1 ? path.split(COMMA) : path;
            return (Array.isArray(path) ? checkSet(obj,path) : checkPaths(obj, path))
        }
        return false;
    }
});